export default __webpack_public_path__ + "static/media/woman-draw-2period.9d5a90d2.svg";